export default __webpack_public_path__ + "static/media/blue-ribbon-pet-boarding.bdcda576.png";